import React from 'react'
import styled from 'styled-components'
import Fab from '@material-ui/core/Fab'
import Icon from '@material-ui/core/Icon'

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  transition: all 0.3s ease;
  ${({show}) => `
    opacity: ${show ? '1' : '0'}
    pointer-events: ${show ? 'auto' : 'none'}
  `}
`

const CustomIcon = styled(Icon)`
  font-size: 3rem;
  color: white;
`

const CloseIcon = () => (<CustomIcon>close</CustomIcon>)

const ShowPreviewButton = styled(Fab)`
  position: absolute;
  top: 2rem;
  right: 2rem;
  width: 5rem;
  height: 5rem;
  z-index: 3;
  ${({disable}) => `
    background-color: ${disable ? 'rgba(0, 0, 0, 0.3)' : 'rgba(33, 150, 243, 0.8)'};
    &:hover {
      background-color: ${disable ? 'rgba(0, 0, 0, 0.3)' : 'rgba(33, 150, 243, 1)'};
    }
  `}
  @media screen and (min-width: 1280px) {
    display: none;
  }
`

const ContentWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`

const Modal = ({
  children,
  onCloseClick,
  show
}) => (
  <ModalContainer show={show}>
    <ShowPreviewButton onClick={onCloseClick}><CloseIcon /></ShowPreviewButton>
    <ContentWrapper>
      {children}
    </ContentWrapper>
  </ModalContainer>
)

export default Modal
